export default __webpack_public_path__ + "static/media/icon-close.30099ff6.svg";